export default "__VITE_PUBLIC_ASSET__2601d0ef__"